<template>
    <div
        class="md-team layout10 mg-bg"
        :class="{ 'isMobile': isMobile }"
        ref="teamLayout10"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            background: bgColor
        }"
    >
        <div class="layout10-container" :class="{'f-col': !isMobile}">
            <div class="agent-wrap" :class="agentDirection"> 
                <swiper
                    class="swiper-container-avatar"
                    v-bind="avatarSwiperOption"
                    @init="onAvatarSwiperReady"
                    @slideChange="onAvatarChange"
                >
                    <slide
                        class="agent agent-avatar"
                        :class="{ 'avatar-active': currIndex == index }"
                        v-for="(agent, index) in agents"
                        :key="agent.id"
                    >
                        <a
                            class="team-layout10-img img-container"
                            ref="layout10Img"
                            :target="detailUrlTarget"
                            :href="
                                useExternalUrl
                                    ? agent.externalUrl || agent.detailUrl
                                    : agent.detailUrl
                            "
                            :style="index === 0 ? imageStyle || {} : {}"
                            rel="noopener noreferrer"
                            :aria-label="agentAlt(agent)"
                        >
                            <AgentHeadShot class="image" ratio="1:1" :agent="agent" />
                        </a>
                    </slide>
                </swiper>
                <div class="line"></div>
                <swiper
                    class="swiper-container-content"
                    v-bind="contentSwiperOption"
                    @init="onContentSwiperReady"
                    @slideChange="onContentChange"
                >
                    <slide
                        v-for="agent in agents"
                        class="agent"
                        :key="agent.id"
                    >
                        <div class="team-layout10-main" v-animated="{name: 'appear-down', enable: isMobileSize ? false : showAnimationEffects}">
                            <div class="main-top">
                                <div
                                    v-if="agent.fullName"
                                    class="agent-name"
                                    :class="{ name: !agent.position }"
                                >
                                    <a
                                        :href="agent.detailUrl"
                                        :target="detailUrlTarget"
                                        rel="noopener noreferrer"
                                        :aria-label="agent.fullName"
                                    >{{ agent.fullName }}</a>
                                </div>
                                <div
                                    class="agent-position"
                                    v-if="
                                        agent.position ||
                                            agent.license ||
                                            agent.licenseWithState
                                    "
                                >
                                    <span v-if="agent.position" class="sp">
                                        {{ agent.position }}
                                    </span>
                                    <span
                                        v-if="
                                            agent.license || agent.licenseWithState
                                        "
                                        class="sp"
                                    >
                                        {{ licenseName }}
                                        {{
                                            agent.licenseWithState || agent.license
                                        }}
                                    </span>
                                </div>
                                <div
                                    class="single-intro"
                                    v-if="agent.longIntroduction"
                                    v-html="agent.longIntroduction"
                                ></div>
                            </div>
                            <div class="main-btm">
                                <Share
                                    v-if="agent.agentSocialNetworks.length"
                                    :socialNetworks="agent.agentSocialNetworks"
                                />
                                <div class="license-company">
                                    <a
                                        v-if="agent.phone"
                                        :href="'tel:' + agent.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        <i class="iconfont icon-phone1"></i>
                                        {{ $ft.formatPhone(agent.phone) }}
                                    </a>
                                    <a
                                        v-if="agent.email"
                                        :href="'mailto:' + agent.email"
                                        :title="$t('common:link.mailtoTitle')"
                                        :aria-label="
                                            $t('common:link.mailtoAriaLabel', {
                                                email: agent.email
                                            })
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        <i class="iconfont icon-v5-email"></i>
                                        {{ agent.email }}
                                    </a>
                                    <p v-if="agent.address">
                                        <i class="iconfont icon-v5-address"></i>
                                        {{ agent.address }}
                                    </p>
                                    <a
                                        v-if="agent.externalUrl"
                                        :href="agent.externalUrl"
                                        :target="detailUrlTarget"
                                        rel="noopener noreferrer"
                                    >
                                        <i class="iconfont icon-icon-test"></i>
                                        {{ agent.externalUrl }}
                                    </a>
                                </div>

                                <site-button
                                    class="book-appointment"
                                    target="_blank"
                                    :href="agent.calendarLink"
                                    v-if="enableBookAppointment && agent.calendarLink"
                                    :html="$t('md-team.bookAppointment')"
                                />
                            </div>
                        </div>
                    </slide>
                </swiper>
            </div>
        </div>
    </div>
</template>
<script>
import common from '../index-layout.js';
import carousel from '../carousel';
import { fixSwiperOptions } from '@/common/swiper';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import Share from '../broker-float/share';
import AgentHeadShot from '@/components/agent-headshot.vue';

export default {
    mixins: [common, carousel],
    components: {
        Share,
        AgentHeadShot
    },
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {},
            currIndex: 0,
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        avatarSwiperOption({ topSwiperOption }) {
            let defaultSwiperOption = {
                direction: 'vertical',
                slidesPerView: this.isMobile ? 'auto' : 1,
                slidesPerGroup: 1,
                loop: false,
                autoplay: false,
                pagination: false,
                navigation: false,
                // mousewheel: {
                //     eventsTarget:"body",
                //     releaseOnEdges: true,
                //     getState:this.handleScroll,
                // },
                grabCursor: true,
                effect: 'creative',
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, '-20%', -1],
                    },
                    next: {
                        translate: [0, '100%', 0],
                    },
                },
            }

            if (topSwiperOption) {
                Object.assign(defaultSwiperOption, topSwiperOption());
            }
            if (this.isMobile) {
                return fixSwiperOptions({
                    ...defaultSwiperOption,
                    spaceBetween: 15,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    slideToClickedSlide: true,
                    direction: 'horizontal',
                    autoHeight: false,
                    mousewheel: false,
                    grabCursor: false,
                    effect: 'slide',
                    creativeEffect: null,
                });
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        },
        contentSwiperOption({ topSwiperOption }) {
            let defaultSwiperOption = {
                direction: 'vertical',
                slidesPerView: this.isMobile ? 'auto' : 1,
                slidesPerGroup: 1,
                loop: false,
                autoplay: false,
                pagination: false,
                navigation: false,
                mousewheel: {
                    eventsTarget: '.md-team',
                    closest: '.md-team',
                    stopScroll: this.stopScroll,
                    releaseOnEdges: true
                },
            };
            if (topSwiperOption) {
                Object.assign(defaultSwiperOption, topSwiperOption());
            }
            if (this.isMobile) {
                return fixSwiperOptions({
                    ...defaultSwiperOption,
                    direction: 'horizontal',
                    spaceBetween: 15,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    autoHeight: true,
                    mousewheel: false,
                });
            } else {
                return fixSwiperOptions(defaultSwiperOption);
            }
        },
       
    },
    methods: {
        onAvatarSwiperReady(swiper) {
            this.avatarSwiper = swiper;
        },
        onContentSwiperReady(swiper) {
            this.contentSwiper = swiper;
        },
        onAvatarChange(swiper) {
            this.currIndex = swiper.realIndex;
            this.contentSwiper?.slideTo(swiper.realIndex);
        },
        onContentChange(swiper) {
            this.currIndex = swiper.realIndex;
            this.avatarSwiper?.slideTo(swiper.realIndex);
        },
        // handleWheel(event) {
        //     if(this.isMobile) return;
        //     if (event.deltaY > 0) {
        //         this.contentSwiper?.slideNext();
        //         this.avatarSwiper?.slideNext();
        //     } else {
        //         this.contentSwiper?.slidePrev();
        //         this.avatarSwiper?.slidePrev();
        //     }
        // },
        setSwiper(flag) {
            // if(flag){
            //     this.contentSwiper?.mousewheel.enable();
            //     this.avatarSwiper?.mousewheel.enable();
            // }else{
            //      this.contentSwiper?.mousewheel.disable();
            //     this.avatarSwiper?.mousewheel.disable();
            // }
            this.contentSwiper && (this.contentSwiper.enabled = flag);
            this.avatarSwiper && (this.avatarSwiper.enabled = flag);
        },
        isEnScroll(direction) {
            const swiper = this.contentSwiper;
            let layout10Dom = this.$refs.teamLayout10;
            let rect = layout10Dom.getBoundingClientRect();
            if (direction < 0) {
                // 往上划
                if (swiper.isEnd) {
                    return true;
                }
                if (rect.top > 100) {
                    return false;
                }
            } else {
                // 往下划
                if (swiper.isBeginning) {
                    return true;
                }
                if (rect.top < 100) {
                    return false;
                }
            }

            return true
        },
        stopScroll(newEvent, swiper) {
            if (this.isMobile) {
                return false; 
            }
            // console.log(newEvent.direction,swiper.isEnd,swiper.isBeginning,rect.top < 220 && rect.top > 100)
            if (this.isEnScroll(newEvent.direction)) {
                return false
            } else {
                return true;
            }

        },
    },
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.layout10 {
    position: relative;

    .agent-wrap {
        width: 100%;
        height: 550px;
        position: sticky;
        top: 180px;
        display: flex;
        flex-direction: row-reverse;
        gap: 100px;
        cursor: pointer;
        @include media-1080 {
            gap: 50px;
        }
        &.left {
            flex-direction: row;
        }
        &.right {
            flex-direction: row-reverse;
        }

        .line {
            width: 1px;
            background: rgba(218, 218, 218, 0.5);
            height: 550px;
        }
    }

    .swiper-container-avatar {
        aspect-ratio: 1;
        border-radius: 50%;
        overflow: hidden;
        height: 100%;
    }
    .swiper-container-content {
        flex: 1; 
        height: 100%;
        overflow: hidden;
    }

    .agent {
        width: 100%;
        height: 100%;
        cursor: pointer;
        .team-layout10-main {
            width: 100%;
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 30px;

            @include media-800 {
                gap: 20px;
            }
            .main-btm {
                display: flex;
                flex-direction: column;
                gap: 30px;
            }
            .main-top {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: column;
            }
            .agent-name {
                color: var(--g-primary-color);
                font-family: var(--mg-title-font);
                font-size: 34px;
                line-height: 1.5;
                text-align: left;
                
                cursor: pointer;
            }
            .agent-position {
                color: var(--g-primary-color);
                opacity: 0.4;
                font-size: 14px;
                line-height: 1.5;
                text-align: left;
                
                margin-top: 10px;
                .sp + .sp:before {
                    content: '|';
                    display: inline-block;
                    padding: 0 5px;
                }
            }
            .single-intro {
                flex: 1;
                margin-top: 20px;
                font-size: 16px;
                line-height: 1.5;
                text-align: left;
                color: var(--g-primary-color);
                overflow-y: auto;
                padding-right: 10px;

                &::-webkit-scrollbar {
                    width: 3px;
                }
                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    position: relative;
                    display: block;
                    width: 0;
                    height: 0;
                    cursor: pointer;
                    background-color: rgba(218, 218, 218, 0.2);
                    -webkit-transition: 0.3s background-color;
                    transition: 0.3s background-color;
                }
            }
            .license-company {
                color: var(--g-text-color);
                font-size: 14px;
                line-height: 1.2;
                display: flex;
                flex-direction: column;
                gap: 10px;
                a, p {
                    display: flex;
                }
                .iconfont {
                    margin-right: 10px;
                }
                .icon-v5-email {
                    font-size: 12px;
                }
            }
            .book-appointment {
                max-width: 300px;
                height: 50px;
                font-size: 16px;
                font-weight: 400;
                background: var(--g-btn-background);
                color: var(--g-btn-color);
                display: flex;
                justify-content: center;
                align-content: center;
                @include media-800 {
                    max-width: 100%;
                    width: 100%;
                }
            }
            .share-links {
                .sn {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 10px;
                }
                .iconfont {
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    color: var(--g-primary-color);
                    font-size: 14px;
                    position: relative;
                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        background: transparent;
                        border: 1px solid var(--g-primary-color);
                        opacity: 0.2;
                    }
                    &:hover::after {
                        opacity: 1;
                    }
                }
            }
        }
        
        .team-layout10-img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            overflow: hidden;
            .img-box {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                overflow: hidden;
            }
        }
    }

    @include media-800 {
        height: auto;
        width: 100%;
 
        .agent-wrap {
            position: static;
            height: auto;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            &.left,
            &.right {
                flex-direction: column;
            }
            .line {
                width: calc(100% - 30px);
                height: 1px;
            }
        }
        .swiper {
            width: 100%;
            height: 300px;
            border-radius: 0;
            &.swiper-container-content {
                flex: none;
                height: auto;
            }
        }
        .agent {
            width: calc(100% - 30px);
            height: auto;
            &:first-child {
                margin-left: 15px;
            }
            &.agent-avatar {
                width: 300px;
                aspect-ratio: 1;
                &:first-child {
                    margin-left: 35px;
                }
            }

            .team-layout10-main {
                flex: none;
                gap: 20px;
                width: 100%;
                height: auto;
                .main-btm {
                    gap: 20px;
                }
                .agent-name {
                    font-size: 18px;
                    line-height: 1.67;
                    font-weight: 600;
                }
                .agent-position {
                    margin-top: 5px;
                    font-size: 12px;
                }
                .single-intro {
                    flex: none;
                    font-size: 14px;
                    position: static;
                    width: 100%;
                    padding-right: 0;
                    overflow-y: visible;
                    height: auto;
                }

                .license-company {
                    > a, > p {
                        line-height: 1.3;
                    }
                }
            }
            .team-layout10-img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
